export class RandomUtil{
    static secureRandom(): number {
      if (window && window.crypto) {
        const array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        return array[0] / (0xffffffff + 1); // Normalize to a float between 0 and 1
      } else {
        throw new Error('Crypto API not available');
      }
    }
  }